export function _filter(value, list) {
  let tmp = value
  list.forEach(obj => {
    if (value === obj.code) {
      tmp = obj.name
      return false
    }
  })
  return tmp
}

export function _setClass(value, list) {
  let tmp = value
  list.forEach(obj => {
    if (value === obj.code) {
      tmp = obj.cls
      return false
    }
  })
  return tmp
}

export const activityList = [
  {name: '鲸融网', cls: 'tc-blue', icon: 'icon-capital', url: 'http://m.capwhale.com/', value: 'url_news'},
  {name: '活动', cls: 'tc-red', icon: 'icon-activity', url: 'http://m.hd.capwhale.com/', value: 'url_hd'},
  {name: '报告', cls: 'tc-orange', icon: 'icon-report', url: 'http://report.capwhale.com/m/mreportindex', value: 'url_report'},
  {name: '直播', cls: 'tc-yellow', icon: 'icon-live', url: 'http://live.capwhale.com', value: 'url_live'}
]
export const question = {
  examstatus: [
    {code: 0, name: '做题', cls: 'tc-yellow'},
    {code: 1, name: '继续', cls: 'tc-yellow'},
    {code: 10, name: '重做', cls: 'tc-green'},
    {code: 11, name: '做完', cls: 'tc-red'}
  ],
  status: [
    {code: 0, name: '考试', cls: 'tc-yellow'},
    {code: 1, name: '继续', cls: 'tc-yellow'},
    {code: 10, name: '已考', cls: 'tc-green'},
    {code: 11, name: '重考', cls: 'tc-red'}
  ]
}

// 订单
export const orderCode = {
  status: [
    {code: 1, name: '待审核', cls: 'tc-yellow'},
    {code: 2, name: '审核通过', cls: 'tc-green'},
    {code: 3, name: '审核失败', cls: 'tc-red'},
    {code: 9, name: '待支付', cls: 'tc-yellow'},
    {code: 98, name: '申请退款', cls: 'tc-yellow'},
    {code: 99, name: '退款', cls: 'tc-yellow'},
    {code: 30, name: '已完成', cls: 'tc-green'},
    {code: 100, name: '已取消', cls: 'tc-grey'}
  ],
  kmcname: [
    {code: 2, name: '报告', cls: 'tc-yellow'},
    {code: 7, name: '课程', cls: 'tc-yellow'},
    {code: 8, name: '题库', cls: 'tc-yellow'},
    {code: 13, name: '活动', cls: 'tc-yellow'},
  ]
}
// 报名
export const apply = {
  fbsj: [
    {code: '', name: '不限',},
    {code: 1, name: '一天以内'},
    {code: 2, name: '三天以内'},
    {code: 3, name: '一周以内'},
    {code: 4, name: '一月以内'}
  ],
  type: [
    {code: '', name: '全部',},
    {code: 1, name: '免费',},
    {code: 2, name: '收费',},
  ],
  status: [
    {code: '', name: '全部',},
    {code: 9, name: '未开始',},
    {code: 10, name: '进行中',},
    {code: 30, name: '已结束',},
  ],
  city: [
    {code: '', name: '全部', value: ''},
    {code: 1, name: '北京', value: '北京'},
    {code: 2, name: '上海', value: '上海'},
    {code: 3, name: '广州', value: '广州'},
    {code: 4, name: '深圳', value: '深圳'},
    {code: 5, name: '杭州', value: '杭州'},
    {code: 6, name: '武汉', value: '武汉'},
    {code: 7, name: '成都', value: '成都'},
    {code: 8, name: '长沙', value: '长沙'},
    {code: 9, name: '南京', value: '南京'},
    {code: 10, name: '重庆', value: '重庆'},
    {code: 11, name: '苏州', value: '苏州'},
    {code: 12, name: '其它', value: '其它'},
  ],
  ticketStatus: [
    {code: 1, name: '待审核', cls: 'tc-orange'},
    {code: 2, name: '审核通过', cls: 'tc-orange'},
    {code: 3, name: '审核拒绝', cls: 'tc-orange'},
    {code: 9, name: '待支付', cls: 'tc-green'},
    {code: 11, name: '支付失败', cls: 'tc-red'},
    {code: 30, name: '报名成功', cls: 'tc-green'}
  ]
}
